import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Banks and Checks sub-navigation (PART 11 §11.2's menu group + FIN-06,
 * which 16.2.2 row 7 places in the banking area): Bank Operations (FIN-12,
 * the group's landing route), Bank Accounts (FIN-09), Incoming Checks
 * (FIN-10), Outgoing Checks (FIN-11), Cash Transfers (FIN-06).
 */
const TABS = [
  { to: '/banks', end: true, key: 'banking.tabOperations' },
  { to: '/banks/accounts', end: false, key: 'banking.tabAccounts' },
  { to: '/banks/checks/incoming', end: false, key: 'banking.tabIncoming' },
  { to: '/banks/checks/outgoing', end: false, key: 'banking.tabOutgoing' },
  { to: '/banks/transfers', end: false, key: 'banking.tabTransfers' },
] as const;

export function BankingTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navBanks')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
